var moduleMap = {
	"./ConsumptionComparison": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_echarts-for-react_esm_index_js-node_modules_react_jsx-runtime_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_prop-types_prop-types"), __webpack_require__.e("webpack_sharing_consume_default_mui_material_mui_material"), __webpack_require__.e("src_ConsumptionComparison_jsx")]).then(() => (() => ((__webpack_require__(78974)))));
	},
	"./Consumption": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_echarts-for-react_esm_index_js-node_modules_react_jsx-runtime_js"), __webpack_require__.e("vendors-node_modules_moment_moment_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_prop-types_prop-types"), __webpack_require__.e("webpack_sharing_consume_default_iobroker_adapter-react-v5_iobroker_adapter-react-v5"), __webpack_require__.e("src_Consumption_jsx")]).then(() => (() => ((__webpack_require__(44173)))));
	},
	"./IntervalSelector": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_moment_moment_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_prop-types_prop-types"), __webpack_require__.e("webpack_sharing_consume_default_mui_material_mui_material"), __webpack_require__.e("webpack_sharing_consume_default_mui_icons-material_mui_icons-material"), __webpack_require__.e("src_IntervalSelector_jsx")]).then(() => (() => ((__webpack_require__(83126)))));
	},
	"./Distribution": () => {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_prop-types_prop-types"), __webpack_require__.e("webpack_sharing_consume_default_iobroker_adapter-react-v5_iobroker_adapter-react-v5"), __webpack_require__.e("src_Distribution_jsx")]).then(() => (() => ((__webpack_require__(62684)))));
	},
	"./translations": () => {
		return __webpack_require__.e("src_translations_js").then(() => (() => ((__webpack_require__(5850)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});